import { useState } from 'react';
import { Modal } from 'antd';
import { EventWithMembership } from '@modules/supabase/events';
import RegisteredAthletesTable from './RegisteredAthletesTable';
import { Button } from '@mui/material';
import { ListAlt } from '@mui/icons-material';
import { isEventAdmin } from '@utils/shared-utils';
import useUser from '@hooks/useUser';
import { STATUS } from '@type/db-types';

export function RegisteredWrestlersButton({ event }: { event: EventWithMembership }) {
    const { user } = useUser();
    const [showModal, setShowModal] = useState(false);
    const adminView = isEventAdmin(user, event.createdByUserId, event.membership);

    return (
        <>
            <Button sx={{ marginX: 1 }} onClick={() => setShowModal(true)} startIcon={<ListAlt />}>
                View registered Wrestlers
            </Button>

            <Modal
                title={
                    <span className="custom-heading">Wrestlers registered to {event?.name}</span>
                }
                open={showModal}
                width={'1200px'}
                footer={false}
                destroyOnClose={true}
                onCancel={() => setShowModal(false)}
            >
                {event ? (
                    <RegisteredAthletesTable
                        adminView={adminView}
                        statuses={[STATUS.ACTIVE]}
                        event={event}
                        onClose={() => setShowModal(false)}
                    />
                ) : null}
            </Modal>
        </>
    );
}
